import { useQuery } from 'react-query';
import { ApiResponse, ResponseModel, User } from '../../../common/interfaces';
import { RequestStatuses } from '../../../constants';
import { LeasingCombination, LeasingCombinationsResponse } from './use-all-leasing-combinations.types';
import { useFetch } from '../../use-fetch/use-fetch';
import { companyRequestConfig } from '../../../request-config/company/company.request-config';
import { useTypedSelector } from '../../use-typed-selector';

const modifyResponse = (response: ApiResponse<LeasingCombinationsResponse>) => {
  if (response?.data.level === RequestStatuses.Success) {
    return response.data.data.leasingCombinations.map(leasingCombination => ({
      ...leasingCombination.attributes,
      id: leasingCombination.id
    }));
  }
  return [];
};

const useAllLeasingCombinations = () => {
  const user = useTypedSelector<User>(state => state.app.user);
  const { fetch } = useFetch<ResponseModel<LeasingCombinationsResponse>>({
    loadingKey: 'useAllLeasingCombinations',
    isCancelRequestOnUnmount: true,
    isShowErrorSnackbar: false,
    ...companyRequestConfig.getLeaseCombinations(user.companyId)
  });

  const { data: allLeasingCombinations, isFetching: isAllLeasingCombinationsFetching } = useQuery<
    ApiResponse<LeasingCombinationsResponse>,
    unknown,
    LeasingCombination[]
  >(['get-all-leasing-combinations', user.companyId], fetch, {
    select: modifyResponse,
    enabled: !!user.companyId
  });

  return {
    allLeasingCombinations,
    isAllLeasingCombinationsFetching
  };
};

export default useAllLeasingCombinations;
